<template>
  <AisSortBy>
    <template #default="{ items, currentRefinement, refine }">
      <BaseSelect
        wrapper-class="text-sm md:text-base has-value"
        label="Järjestä"
        hide-label
        name="product-list-sort-by"
        @change="refine(($event.currentTarget as HTMLInputElement)?.value)"
      >
        <option
          v-for="item in items"
          :key="item.value"
          :value="item.value"
          :selected="item.value === currentRefinement"
        >
          {{ item.label }}
        </option>
      </BaseSelect>
    </template>
  </AisSortBy>
</template>

<script setup lang="ts">
//
</script>
